import {Paper, Slide} from "@mui/material";
import Box from "@mui/material/Box";
import {Info} from "@mui/icons-material";
import Typography from "@mui/material/Typography";
import useHelper from "../../../../../../use/useHelper";

export default function ({appointment}) {
    const helper = useHelper();

    return (
        <Slide direction={"left"} in={true} timeout={500}>
            <Paper elevation={3} data-test="insurance-notify-appointment">
                <Box display="flex" alignItems={"center"} px={2} py={1}>
                    <Box display="flex" alignItems={"center"}>
                        <Info color={"warning"}/>
                    </Box>
                    <Box ml={1}>
                        <Typography display="inline">
                            Le sociétaire vous attend&nbsp;
                        </Typography>
                        <Typography display="inline" fontWeight={"bold"} color={"warning"}>
                            le {helper.formatDate(appointment)}
                        </Typography>
                        <Typography display="inline">
                            .
                        </Typography>
                    </Box>
                </Box>
            </Paper>
        </Slide>
    )
}
